import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  flow,
  types,
} from 'mobx-state-tree';

import { request, debug, track } from 'lib';

const log = debug.create('performing');
const error = debug.create('performing:error');

const initState = {};

const PerformingModel = types
  .model('PerformingModel', {
    // 0: 未开始 1: 进行中 2: 冷却中
    status: 0,
    // SINGER 演唱，DANCER 热舞
    type: '',
    remain: 0,
    // 当前类型对应的总数，热舞总数
    total: 0,
    month_count: 0,

    // 当月无效表演次数
    invalid_count: 0,
    // 当日有效表演次数
    valid_count: 0,

    // 每日有效表演次数上限
    max_valid_count: 0,
    // 单场表演时长/秒
    live_second: 0,
  })
  .views((self) => {
    return {
      get typeName() {
        return (
          {
            SINGER: '劲歌',
            DANCER: '热舞',
          }[self.type] || ''
        );
      },
      get actionName() {
        return (
          {
            SINGER: '唱歌',
            DANCER: '热舞',
          }[self.type] || ''
        );
      },
    };
  })
  .actions((self) => {
    const decreaseRemain = () => {
      if (self.remain > 0) {
        self.remain -= 1;
      }
    };
    return {
      decreaseRemain,
    };
  });

const Model = types
  .model('Model', {
    performingInfo: types.optional(PerformingModel, {}),
  })
  .actions((self) => {
    const update = flow(function* () {
      let res;
      try {
        res = yield request.cryolite.get(`/api/v1/performing/info`);
        self.performingInfo = res.data;
        log('update performing success');
      } catch (e) {
        error('update performing error', e);
      }
    });

    const setNextStep = () => {
      const data = {
        status:
          self.performingInfo.status === 0 ? 1 : self.performingInfo.status,
        type: self.performingInfo.type,
        remain: 0,
      };
      self.performingInfo = data;
    };

    const setStatus = (status) => {
      self.performingInfo.status = status;
    };
    return {
      update,
      setNextStep,
      setStatus,
    };
  });

export default {
  initState,
  Model,
};
